import { WThemeAPIView } from './types';
import LeftLeaf from '../assets/cruise/left_leaf.png';
import RightLeaf from '../assets/cruise/right_leaf.png';
import LeftLeaf2 from '../assets/cruise/left_leaf_2.png';

const CruiseAPI: WThemeAPIView = {
  typography: {
    h1_font: {
      font_family: 'Roboto Condensed',
      font_color: '#444444',
      font_size: 80,
      font_weight: 700,
      line_height: '1.2', // only ratio of font-size which resizes at different breakpoints
      text_transform: 'uppercase',
    },
    h2_font: {
      font_family: 'Roboto Condensed',
      font_color: '#444444',
      font_size: 56,
      font_weight: 700,
      line_height: '1.2',
      text_transform: 'uppercase',
    },
    h3_font: {
      font_family: 'Roboto Condensed',
      font_color: '#444444',
      font_size: 40,
      font_weight: 700,
      line_height: '1.2',
      text_transform: 'uppercase',
    },
    h4_font: {
      // previously "compliment font"
      font_family: 'Proxima Nova',
      font_color: '#444444',
      font_size: 30,
      font_weight: 400,
      line_height: '1',
      text_transform: 'uppercase',
    },
    body_font: {
      // fallback for divs
      font_family: 'Proxima Nova',
      font_color: '#444444',
      font_size: 20,
      font_weight: 400,
      line_height: '1',
    },
    p_font: {
      // paragraph styles specifically
      font_family: 'Proxima Nova',
      font_color: '#444444',
      font_size: 20,
      font_weight: 400,
      line_height: '1.6',
    },
  },
  // accent_color: '',
  background: { background_color: '#FFFFFF' },
  light_or_dark: 'light',
  // HTML ELEMENT STYLING
  button_styles: {
    primary: {
      background_color: '#15845D',
      border_radius: '4px',
      font: {
        font_family: 'Proxima Nova',
        font_color: '#FFFFFF',
        font_size: 16,
        font_weight: 600,
        line_height: '16px',
        text_transform: 'none',
      },
      pseudo_active: {
        font_color: '#FFFFFF',
        background_color: '#007F54',
      },
      pseudo_hover: {
        font_color: '#FFFFFF',
        background_color: '#1BAE7D',
      },
      pseudo_disabled: {
        font_color: '#FFFFFF',
        background_color: '#6C757D',
      },
    },
  },
  // input: {},
  // checkbox: {},
  // radio: {},
  container: {
    assets: {
      absolute: [
        {
          src: RightLeaf,
          altText: 'decorative leaf',
          responsiveStyles: {
            desktop: {
              width: { unit: 'px', value: 300 },
              top: '450px',
              right: '0',
              zIndex: -200, // options are bg; over text, under image; under text, over image; over text
            },
          },
        },
        {
          src: LeftLeaf2,
          altText: 'decorative leaf',
          responsiveStyles: {
            desktop: {
              width: { unit: 'px', value: 300 },
              left: '0',
              top: '0',
              zIndex: -400,
            },
          },
        },
        {
          src: LeftLeaf,
          altText: 'decorative leaf',
          responsiveStyles: {
            desktop: {
              width: { unit: 'px', value: 200 },
              left: '0',
              top: '1000px',
              zIndex: -200,
            },
          },
        },
      ],
    },
  },
  header: {
    background: { background_color: '#FFFFFF' },
    title: {
      font: {
        // previously "nav_header_font"
        font_family: 'Roboto Condensed',
        font_color: '#444444',
        font_size: 42,
        font_weight: 700,
        line_height: '1.3',
        text_transform: 'uppercase',
      },
    },
    nav_item: {
      font: {
        // previously "nav_subheader_font"
        font_family: 'Proxima Nova',
        font_color: '#444444', // used for mobile hamburger
        font_size: 16,
        font_weight: 400,
        line_height: '1',
        text_transform: 'none',
      },
    },
  },
  homepage: {
    display_type: 'DISPLAY_TYPE_1',
    // content_alignment: 'center',
    // indexed by component
    hero: {
      display_type: 'DISPLAY_TYPE_1',
    },
    name: {
      display_type: 'DISPLAY_TYPE_1',
    },
    date_location: {
      display_type: 'DISPLAY_TYPE_1',
    },
  },
};

export default CruiseAPI;
